import { GIFileType } from '@enums/gi-file-type.enum';
import { EmailAttachment, EmailAttachmentJsonSerialized } from '@models/email-attachment';

export interface GiEmailAttachmentJson {
  id: number;
  type: string;
  name: string;
  content: string;
  file: Blob;
  title: string;
  contract_file_type: GIFileType;
}

export class GiEmailAttachment extends EmailAttachment {
  constructor(
    id?: number,
    type?: string,
    name?: string,
    content?: string,
    file?: Blob,
    title?: string,
    public contractFileType?: GIFileType
  ) {
    super(id, type, name, content, file, title);
    this.contractFileType = contractFileType;
  }

  static fromJson(json: Partial<GiEmailAttachmentJson>): GiEmailAttachment {
    return new GiEmailAttachment(
      json.id,
      json.type,
      json.name,
      json.content,
      json.file,
      json.title,
      json.contract_file_type
    );
  }

  static toJson(contractEmailAttachment: GiEmailAttachment): EmailAttachmentJsonSerialized {
    return EmailAttachment.toJson(contractEmailAttachment);
  }
}
